module.exports = __webpack_public_path__ + "img/master.b9866251.png";